module.exports = __webpack_public_path__ + "img/option2.6b04d040.png";